export enum OrderedProductStatuses {
    TO_PREPARE = 'TO_PREPARE',
    PREPARED = 'PREPARED' 
}

export type OrderedProductStatus = OrderedProductStatuses.TO_PREPARE
    | OrderedProductStatuses.PREPARED;
